export class ToggleMenu {
    public static readonly type = '[Menu] toggle';
}

export class OpenMenu {
    public static readonly type = '[Menu] open';
}
